"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var murmurhash3js_1 = require("murmurhash3js");
exports.drawAbTestVariationForUser = function (userId, abTest) {
    var bucket = (murmurhash3js_1.x86.hash32(userId + "#" + abTest.id) % 100) + 1;
    var acc = 0;
    return {
        bucket: bucket,
        variationId: abTest.variations.find(function (variation) {
            acc += variation.weight;
            return acc >= bucket;
        }).id
    };
};
//# sourceMappingURL=abTest.js.map